import moment from 'moment';
// Format Date in calendar format
// e.g Today, Tomorrow, Yesterday ...
// @see https://momentjs.com/docs/#/displaying/calendar-time/
export function toCalendarTime(date) {
    return moment(date).calendar('', {
        sameDay: '[Today]',
        nextDay: '[Tomorrow]',
        nextWeek: 'dddd',
        lastDay: '[Yesterday]',
        lastWeek: '[Last] dddd',
        sameElse: 'DD/MM/YYYY',
    });
}
